export default "__VITE_ASSET__HAhhpQX___"